import { useI18n } from "../../lib/i18n";

/**
 * SCAFFOLD ONLY. Every value in square brackets must be filled in by the
 * operator with real, verified company/contact/registration data. Do NOT
 * auto-fill any of these placeholders — § 5 TMG requires accurate,
 * operator-supplied information.
 */
const FIELDS = [
  { key: "company",   label: "Company / Firma",           placeholder: "[OPERATOR: legal entity name]" },
  { key: "address",   label: "Address / Anschrift",       placeholder: "[OPERATOR: street, no., ZIP, city, country]" },
  { key: "represent", label: "Represented by / Vertreten durch", placeholder: "[OPERATOR: name(s) of legal representative(s)]" },
  { key: "contact",   label: "Contact / Kontakt",         placeholder: "[OPERATOR: email · phone]" },
  { key: "register",  label: "Register entry / Registereintrag", placeholder: "[OPERATOR: register court, HRB number]" },
  { key: "vatid",     label: "VAT ID / Umsatzsteuer-ID",  placeholder: "[OPERATOR: USt-IdNr. §27a UStG]" },
  { key: "editor",    label: "Editorial responsibility / Redaktionell verantwortlich (§ 18 MStV)", placeholder: "[OPERATOR: name & address of responsible person]" },
  { key: "supervisory", label: "Supervisory authority / Aufsichtsbehörde", placeholder: "[OPERATOR: relevant authority, if applicable]" },
  { key: "disputes",  label: "EU ODR / Streitschlichtung", placeholder: "[OPERATOR: EU-ODR link + statement whether operator participates in dispute resolution]" },
];

export default function Imprint() {
  const { t } = useI18n();
  return (
    <article className="max-w-3xl mx-auto px-6 py-16 lg:py-20">
      <div className="font-mono text-[11px] uppercase tracking-widest text-[#2DD4A7] mb-3">Legal</div>
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mb-4" data-testid="legal-imprint-title">{t("footer.imprint")}</h1>
      <p className="text-xs text-[#F5B841] mb-10 font-mono uppercase tracking-widest" data-testid="legal-imprint-scaffold-notice">Draft scaffold — operator must supply final copy</p>
      <div className="text-[#8B97AE] leading-relaxed space-y-6 text-sm">
        <p>{t("legal.placeholder")}</p>
        <p><strong className="text-[#E8ECF4]">Angaben gemäß § 5 TMG:</strong></p>
        <dl className="space-y-4">
          {FIELDS.map((f) => (
            <div key={f.key} data-testid={`legal-imprint-field-${f.key}`} className="border-l-2 border-white/10 pl-4">
              <dt className="font-mono text-[10px] uppercase tracking-widest text-[#E8ECF4] mb-1">{f.label}</dt>
              <dd className="font-mono text-[#F5B841] text-xs">{f.placeholder}</dd>
            </div>
          ))}
        </dl>
        <p className="text-[10px] font-mono uppercase tracking-widest text-[#8B97AE] pt-8 border-t border-white/10" data-testid="legal-imprint-effective-date">Last updated: [OPERATOR: date]</p>
      </div>
    </article>
  );
}
